import { lightboxLicenseKey } from "@/lib/config/env.public";
import LightGallery, { LightGalleryProps } from "lightgallery/react";
import "lightgallery/css/lightgallery.css";

const licenseKey = lightboxLicenseKey();

const Lightbox: React.FC<LightGalleryProps> = (props) => {
  return <LightGallery {...props} licenseKey={licenseKey} />;
};

export default Lightbox;
